import React, { useState } from "react";
import "./Contact.scss";
import { MdLocationOn } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { Helmet } from "react-helmet";
import Mail from "./Mail/Mail";
import Mobile from "./Mobile/Mobile";
import Location from "./Location/Location";
import Office from "./Office/Office";

const Contact = () => {
  const [activeTab, setActiveTab] = useState("mail");

  const renderTabContent = () => {
    switch (activeTab) {
      case "mail":
        return <Mail />;
      case "contact":
        return <Mobile />;
      case "location":
        return <Location />;
      default:
        return null;
    }
  };

  return (
    <div className="contact-page">
      <Helmet>
        <title>Best IT Company For College Internship In Vadodara</title>
        <meta
          name="title"
          content="Best IT Company For College Internship In Vadodara."
        />
        <meta
          name="description"
          content="Live project training in web development, app development, and more at V-Ex Tech Solution, Vadodara."
        />
      </Helmet>

      <Office />

      <div className="contact-container">
        <div className="contact-card">
          <div className="contact-header">
            <h1>Get in Touch!</h1>
            <p>Contact us for more information and support.</p>
          </div>

          {/* Tabs */}
          <div className="contact-tabs">
            <div
              className={`tab ${activeTab === "mail" ? "active" : ""}`}
              onClick={() => setActiveTab("mail")}
            >
              <IoIosMail />
              <span>Message</span>
            </div>

            <div
              className={`tab ${activeTab === "contact" ? "active" : ""}`}
              onClick={() => setActiveTab("contact")}
            >
              <FaPhoneAlt />
              <span>Contact</span>
            </div>

            <div
              className={`tab ${activeTab === "location" ? "active" : ""}`}
              onClick={() => setActiveTab("location")}
            >
              <MdLocationOn />
              <span>Location</span>
            </div>
          </div>

          {/* Tab content */}
          <div className="tab-content fade-in">{renderTabContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
